/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

export const customMinValueValidation = (
  value = 0,
  fieldName = ''
): ValidatorFn => {
  const funcProperties = {
    value: value,
    fieldName: fieldName,
  };

  return _customMinValueValidation.bind(funcProperties);
};

function _customMinValueValidation(this: any, control: AbstractControl): {
  [key: string]: any;
} | null {
  if (control.value != null && control.value < this.value) {
    return {
      severity: ErrorSeverityEnum.error,
      message: 'minValueExceeded' + this.fieldName,
    };
  }

  return null;
}
